export default function ToggleClass(element, className) {
	if (element.length>0) {
		element.forEach(el => {
			el.addEventListener("click", function() {
				const next = this.nextElementSibling;
				next.classList.toggle(className);
			})
		});
	}
}